import { render, staticRenderFns } from "./fishTable.vue?vue&type=template&id=f6b5a810&scoped=true"
import script from "./fishTable.vue?vue&type=script&lang=ts"
export * from "./fishTable.vue?vue&type=script&lang=ts"
import style0 from "./fishTable.vue?vue&type=style&index=0&id=f6b5a810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5a810",
  null
  
)

export default component.exports